import type { EntitlementState } from '@/features/entitlement/engine';

const LABEL: Record<EntitlementState, string> = {
  entitled: 'Entitled',
  'not-entitled': 'Not entitled',
  indeterminate: 'Indeterminate',
};

export function StateBadge({ state }: { state: EntitlementState }) {
  return <span className={`badge badge--${state}`}>{LABEL[state]}</span>;
}
